import React from "react";
import { Container } from "react-bootstrap";
import aiIot from "../../../../Asset/hero-ai-lot3.svg";

const Second = () => {
  return (
    <>
      <section
        className="side-image-box-section"
        style={{ backgroundColor: "var(--white-color)" }}
      >
        <Container>
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-12 order-2 order-md-2">
              <div className="info-content">
                <p>
                  Our wing of IoT solutions has been designed in a way to help
                  you monitor, analyse and control your organizations’ data,
                  thereby minimizing risk and optimizing business processes and
                  operations.
                </p>
                <div className="title-ul">Sectors</div>
                <ul className="check-list count_2 pt-4">
                  <li>Agriculture</li>
                  <li>Healthcare</li>
                  <li>Manufacturing</li>
                  <li>Energy</li>
                  <li>Real Estate</li>
                  <li>Technology</li>
                  <li>Telecommunication</li>
                  <li>Transport</li>
                </ul>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 order-1 order-md-1">
              <div className="info-img">
                <img alt="infoImage" src={aiIot} className="w-100" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Second;
